// extracted by mini-css-extract-plugin
export default {"dashboard_col_3":"Dashboard_dashboard_col_3__-fha+","dashboard_col_9":"Dashboard_dashboard_col_9__Eyhw1","navbar_sticky":"Dashboard_navbar_sticky__MKCWx"};